import { PetplaceMakePaymentCard } from "../../../../UI-Component-Library";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "../../../../custom-axios";
import { saveCartData } from "../../../../redux/reducers/membership-purchase-reducer";
import { ApiConstants } from "../../../../utils/api-constants";
import { AppUtils } from "../../../../utils/app-utils";
import { DataLayerUtils } from "../../../../utils/dataLayer-utils";
class MakePaymentWrapper extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedCard: "",
      errorMessage: "",
      isPayingWithDifferentCard: false,
      existingCards: [],
    };
    this.cRef = React.createRef();
  }
  proceedToCheckout() {
    const cartData = this.props.cartData;
    const animalId = this.props.animalId;
    const planId = this.props.planId;
    const orderItems = this.props.extractCartData(cartData, true);
    if (
      this.state.isPayingWithDifferentCard ||
      this.state.existingCards?.length === 0
    ) {
      DataLayerUtils.beginCheckoutEvent(orderItems, cartData?.total);
      this.props.history.push({
        pathname:"/petplace/payment",
        state: {
          orderItems,
          animalId,
          planId,
        }
      });
    }

    const selectedCard = this.state.existingCards.find(
      (card) => card.active === true
    );
    const errorMessage = !selectedCard ? "Card is not selected" : "";
    this.setState({
      errorMessage,
    });
    if (!errorMessage && this.props.cartData) {
      axios
        .processPost(
          `${ApiConstants.URL_CHECKOUT_SHOPPING_CART}${this.props.cartData.cartId}`,
          this.cRef,
          {
            token: selectedCard.tokenId,
            cardType: selectedCard.cardType,
            maskedCardNumber: selectedCard.ccLastFour,
            countrycode: AppUtils.getCountryCode(),
          }
        )
        .then((response) => {
          this.props.history.push({
            pathname: "/petplace/payment/success",
            state: orderItems
          });
        })
        .catch((err) => {
          let errors = err?.response?.data?.errors;
          if (errors && errors.length > 0) {
            this.setState({
              errorMessage: errors[0],
            });
          }
        });
    }
  }
  handleCardSelection(
    tokenId,
    resetAll = false,
    isPayingWithDifferentCard = false
  ) {
    DataLayerUtils.selectPaymentMethodEvent(AppUtils.getUserRelationId());
    const existingCards = this.state.existingCards.map((card) => {
      return {
        ...card,
        active: AppUtils.isEqualString(card.tokenId, tokenId) && !resetAll,
      };
    });
    this.setState({
      existingCards,
      isPayingWithDifferentCard: isPayingWithDifferentCard,
    });
  }
  handleNewCardSelection() {
    this.handleCardSelection("", true, !this.state.isPayingWithDifferentCard);
  }
  fetchCreditCards() {
    axios
      .processGet(
        `${ApiConstants.URL_DISPLAY_CC_CARDS}${AppUtils.getBusRelAccount()}`,
        this.cRef
      )
      .then((response) => {
        const cards = response.data;
        const existingCards = [];
        cards.forEach((card) => {
          existingCards.push({
            active: false,
            onClick: () => {
              this.handleCardSelection(card.tokenId);
            },
            description: `${card.paymMode} •••• ${card.ccLastFour}`,
            tokenId: card.tokenId,
            cardType: card.paymMode,
            ccLastFour: card.ccLastFour,
          });
        });
        this.setState({
          existingCards,
        });
      })
      .catch((err) => {
        let errors = err?.response?.data?.errors;
        if (errors && errors.length > 0) {
          this.setState({
            errorMessage: errors[0],
          });
        }
      });
  }
  componentDidMount() {
    this.fetchCreditCards();
  }
  render() {
    return (
      <div ref={this.cRef}>
        <PetplaceMakePaymentCard
          caption={
            this.state.existingCards?.length > 0
              ? "Use a saved card or add a new payment method."
              : "You do not have a credit card saved. Click below to add a payment method."
          }
          errorMessage={this.state.errorMessage}
          existingCardOptions={this.state.existingCards}
          payWithDifferentCardOption={{
            hidden: this.state.existingCards?.length > 0 ? false : true,
            active: this.state.isPayingWithDifferentCard,
            onClick: () => {
              this.handleNewCardSelection();
            },
          }}
          continueButtonProp={{
            label:
              this.state.existingCards?.length > 0
                ? "Continue"
                : "Add Payment Method",
            disabled: this.props.disableCheckoutButton,
            id: "buttonId",
            onClick: () => {
              this.proceedToCheckout();
            },
          }}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const membershipPurchaseStore = state.membershipPurchaseStore;
  const customerProfileStore = state.customerProfileStore;

  return {
    cartData: membershipPurchaseStore.cartData,
    promoCode: membershipPurchaseStore.promoCode,
    customerAnimals: customerProfileStore.customerAnimals,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveCartData: (data) => dispatch(saveCartData(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MakePaymentWrapper));
